import { memo, useState } from "react";

import { Popover } from "antd";
import { useChartsContext } from "contexts";

import { useChartEntities } from "hooks/charts";

import LineOfBestFit from "components/icons/LineOfBestFit";

import ToolbarButton from "../../base/ToolbarButton";
import BestFitOptions from "./best-fit-options/BestFitOptions";

const BestFitToggle = () => {
  const [visible, setVisible] = useState(false);
  const { id } = useChartsContext();

  const { bestFitToggle } = useChartEntities(id);
  const isActive = bestFitToggle?.active;

  return (
    <Popover
      arrowPointAtCenter
      content={<BestFitOptions />}
      placement="bottomRight"
      trigger="click"
      open={visible}
      onOpenChange={(v) => setVisible(v)}>
      <ToolbarButton
        key={"BestFitToggle" + isActive}
        data-testid="best-fit-toggle"
        icon={<LineOfBestFit />}
        active={isActive}
        overflowLabel="Line of Best Fit"
        tooltipText="Line of Best Fit"
      />
    </Popover>
  );
};

export default memo(BestFitToggle);
